'use client';
import { HugeiconsIcon } from '@hugeicons/react';
import { Car04Icon, DiscountIcon } from '@hugeicons/core-free-icons';
import { TbCoinTaka } from 'react-icons/tb';
import { PromoBannerSlider } from './PromoBannerSlider';
import { useFetcherCSR } from '@/lib/useFetcherCSR';

interface SettingsType {
  type: string;
  value: string;
}

// The component is now ASYNC
const PromoBanner = () => {
  // Fetch data directly on the server. This happens during the server render.
  const { data } = useFetcherCSR(`/api/v2/general-settings`);

  const settings = data?.data ?? [];
  const shippingCost =
    settings.find((item: any) => item.type === 'min_amount_free_shipping')
      ?.value ?? 'N/A';
  const minShippingAmount =
    settings.find((item: any) => item.type === 'default_shipping_cost')
      ?.value ?? 'N/A';

  const promoItems = [
    {
      icon: <HugeiconsIcon icon={Car04Icon} size={48} />, // Slightly smaller for better fit
      title: `Free Shipping on Orders Over ${shippingCost} BDT`,
      subtitle: 'For All Products',
    },
    {
      icon: <TbCoinTaka size={48} />,
      title: 'Up To 10% OFF On All Items',
      subtitle: 'Available for J-Beauty Users Group!',
      link: 'https://www.facebook.com/groups/520245052204738',
    },
    {
      icon: <HugeiconsIcon icon={DiscountIcon} size={48} />,
      title: `Flat ${minShippingAmount} TK delivery charge`,
      subtitle: 'All over the country!',
    },
  ];

  return (
    <div className="promo-banner">
      <div className="container">
        <PromoBannerSlider items={promoItems} />
      </div>
    </div>
  );
};

export default PromoBanner;
